import router from "../../../router/index";

import { store } from "../../../utils/store";
import errorManager from "./error-manager";

const unauthStatus = [401, 403];

class ErrorInterceptor {
  isUnAuth(error) {
    return unauthStatus.includes(error.status);
  }

  //TODO case installer is trying to access monitoring of not own antenna
  // intercept if is auth and send back to login, the front end shoud never send unauthorized request from the page where the user is authorized to navigate
  expiredAuth(error) {
    if (this.isUnAuth(error)) {
      store.logout();
      router.push("/login");
    }
    return error;
  }

  // he intercept the response in axios, it HELP with the identification of the error and is the axios interceptor to decide what to do
  // the result may depends on the nature of the request
  helper(error) {
    console.log(error);
    if(error.code=="ERR_CANCELED"){
    return error;
    }
    if (error.response) {
      if (error.response.status === 401) {
        console.log("UNAUTHORIZED 401");
      }
      if (error.response.status === 403) {
        console.log("FORBIDDEN 403");
      }
      if (error.response.status === 400) {
        console.log("BAD REQUEST 400");
      }
      if (error.response.status === 404) {
        console.log("NOT FOUND 404");
      }
      if (error.response.status === 409) {
        console.log("CONFLICT 409");
      }
      if (error.response.status >= 500) {
        console.error("SERVER ERROR 500", error.response.data);
        let errorServer = {
          status: error.response.status,
          message: "Something went wrong... ",
          error: "ServerError",
          data: error.response,
        };
        if (error.response.data && error.response.data.message) {
          errorServer.message =
            error.response.data.message + " " + error.response.data.errorId;
        }
        if (error.response.status == 504) {
          console.error("SERVER ERROR 500", error.response.data);
          errorServer = {
            status: error.response.status,
            message: "Something went wrong... ",
            error: "TimeoutUpstream",
            data: error.response,
          };
          if (error.message.includes("timeout")) {
            errorServer.message = error.message;
          }
        }
        //
        return errorServer;
      }
      return error.response;
    }

    if (error.message == "Network Error") {
      console.log("Network Error");
      return "NetworkError";
    }
    if (error.message.includes("TypeError")) {
      console.log("TypeError");
      return "TypeError";
    }
    return error.message;
  }

  serverError(error) {
    if (error == "NetworkError" || error.error == "ServerError") {
      errorManager.pushServerError(error, router.currentRoute.value.fullPath);
    }
  }
  // (redirect with message, request info required)
  // NOT FOUND PAGE if the content is 404 for request with path params
  // SERVER ERROR PAGE if 500 502 503 NetworkError
  // if the user attempt navigation but navigation fail it will be redirected
  // UNAUTHORIZE PAGE if token not expired 403 401 unauthorized content for request with path params

  //
}

export default new ErrorInterceptor();
